import { DefaultService } from '@/services/DefaultService';


export default class AssTabPrecoClienteService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/asstabprecocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/asstabprecocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/cliente/asstabprecocliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(asstabprecocliente) {
        return this._http.post(`${this._env}/ven/cliente/asstabprecocliente/updatesituacao`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(asstabprecocliente) {
        return this._http.post(`${this._env}/agro/cliente/asstabprecocliente/updatesituacao`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/asstabprecocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/asstabprecocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(asstabprecocliente) {
        return this._http.post(`${this._env}/ven/cliente/asstabprecocliente`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(asstabprecocliente) {
        return this._http.post(`${this._env}/agro/cliente/asstabprecocliente`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAssVendas(asstabprecocliente) {
        return this._http.post(`${this._env}/ven/cliente/asstabprecocliente/save`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAssAgro(asstabprecocliente) {
        return this._http.post(`${this._env}/agro/cliente/asstabprecocliente/save`, asstabprecocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}